<template>
    <div class="new-menu1 new-menu2 new-menu3" style="margin-left:0px ;padding: 0;left:200px;height: 100%;">
        <el-menu _background-color="#0D5788" mode="vertical" :default-active="defaultActiveMenu"  active-text-color="#409EFF" :unique-opened="uniqueOpened"
            :collapse="menuCollapse" :collapse-transition="true">
          <template v-for="item in this.customGlobal.userMenuForPermission">
            <el-submenu :index="item.id" v-if="item.status==='true'||item.status===true " @click.native="selectItems(item)">
              <template slot="title">
<!--                  <i :class="item.icon!==undefined?item.icon:'el-icon-menu'"></i>-->
                  <i v-if="item.icon" :class="item.icon"></i>
                  <span slot="title">{{ item.caption }}</span>
              </template>
              <template v-for="item1 in item.detail">
                <el-menu-item v-if="item1.status==='true'||item1.status===true" :index="item1.id" @click.native="selectItems2(item1,item.id)">
                    <template slot="title">
<!--                        <i :class="item1.icon?item1.icon:'el-icon-menu'"></i>-->
                         <i v-if="item1.icon" :class="item1.icon"></i>
                        <span slot="title" _class="el-menu-item">{{ item1.caption }}</span>
                    </template>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
    </div>
</template>
<script>
var linkTo = new Array()
export default {
    name: 'IndexLeft',
    created() {
        //排序
        this.customGlobal.userMenuForPermission = this.customGlobal.jsonSort(
            this.customGlobal.userMenuForPermission
        )
        // linkTo = new Array()
        // for (
        //     let i1 = 0;
        //     i1 < this.customGlobal.userMenuForPermission.length;
        //     i1++
        // ) {
        //   if(this.customGlobal.userMenuForPermission[i1].detail) {
        //     for (
        //       let i2 = 0;
        //       i2 < this.customGlobal.userMenuForPermission[i1].detail.length;
        //       i2++
        //     ) {
        //       linkTo.push({
        //         url: this.customGlobal.userMenuForPermission[i1].detail[i2]
        //           .url,
        //         caption:
        //         this.customGlobal.userMenuForPermission[i1].detail[i2]
        //           .caption,
        //       })
        //     }
        //   }
        // }
        // this.linkMenu = linkTo
    },
    data: function () {
        return {
            // linkMenu: linkTo,
            menuCollapse: false,
            uniqueOpened: true,
            defaultActiveMenu: '',
            // defaultOpeneds: ['M_B_20220527_142000907_108451552']
            defaultOpeneds: []
        }
    },
    methods: {
        //带有父ID
        selectItems2: function (item1, parentId) {
            //console.info("url:"+item1.url+",caption:"+item1.caption)
            //this.$router.push({path:url});
            this.$emit('parent_method', {
                id: item1.id,
                caption: item1.caption,
                url: item1.url,
                vue: item1.vue,
                parentId: parentId,
            })
        },
        //不带父ID
        selectItems: function (item) {
            if (!item.url || item.url === '未定义') {
              return
            }
            this.$emit('parent_method', {
                id: item.id,
                caption: item.caption,
                url: item.url,
                vue: item.vue
            })
        },
        openCloseMenu() {
            this.menuCollapse = !this.menuCollapse
        },
        handleOpen(key, keyPath) {
            //console.log(key, keyPath);
            this.defaultOpeneds = [] //close all
            this.defaultOpeneds = [key] //open parent
        },
        activeMenu(args) {
            // this.menuCollapse = true
            this.defaultOpeneds = [] //close all
            this.defaultActiveMenu = args.id //active menu
            // this.defaultOpeneds = [args.parentId] //open parent
        },
    },
}
</script>

<style scoped>
/* <style > */

/* 水平菜单顶层菜单样式 */
/* >符号表示直接孩子，.el-menu--horizontal>.el-submenu .el-submenu_title表示的
是类.el-menu--horizontal元素（这个是顶层菜单el-menu）下的第一层元素（sub-menu）下的标题，
这个标题是放在<i>元素的slot属性中的，从而找到了<i>元素，修改它的样式就可以了 */
.new-menu1 /deep/ .el-menu > .el-submenu .el-submenu__title {
    padding-left: 15px !important;
    text-align: left !important;
    font-weight: bold !important;
    font-size: 14px !important;
    /*height: 40px !important;*/
    /*line-height: 40px !important;*/
}
/* 水平菜单子菜单的标题（注意，标题和菜单项不一样，标题是使用<i slot="title">表示的，需要单独处理），
这里使用.el-submenu>.el-submenu_title定位到子菜单（不是菜单项） */
/*.el-menu .el-menu .el-submenu>.el-submenu__title {*/
/*  padding-left: 15px !important;*/
/*  text-align: left !important;*/

/*}*/
/* 水平菜单子菜单中的所有菜单项 */
.new-menu2 /deep/ .el-menu .el-menu .el-menu-item {
    /*padding-left: 15px !important;*/
    padding-left: 30px !important;
    text-align: left !important;
    /*height: 40px !important;*/
    /*line-height: 40px !important;*/
}
.new-menu3 /deep/ .el-menu--collapse .el-menu .el-submenu .el-menu--popup {
    min-width: 160px !important;
    height: 46px !important;
    line-height: 46px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/IndexLeft.vue